module.exports = __webpack_public_path__ + "img/voltage-rock.5146c1f4.png";